import { GeocodePrecision } from './Geo';

/**
 * Backend #678 / web #172: `GET api/catalog/catalogitems/pins` — one pin per seller over the
 * ENTIRE result set of the same filter (paging and sort ignored), only sellers with at least one
 * `Available` listing (backend decision 2: an imported „Beim Anbieter erhältlich" listing stays
 * in the list with a distance but never produces a pin — the backend decides that, the client
 * never filters pins itself), nearest first with an origin, best-stocked first without one.
 */
export interface CatalogPin {
  sellerCustomerId: string;
  sellerName: string;
  latitude: number;
  longitude: number;
  /** `postalCode` is a private seller's centroid (decision 5): draw an area, not a point. */
  geocodePrecision: GeocodePrecision;
  /** Matching listings of this seller. */
  itemCount: number;
  /** From the origin, as the crow flies; null without an origin. */
  distanceKm: number | null;
}

export interface CatalogPins {
  pins: CatalogPin[];
  /** Sellers in the result — more than `pins.length` when `truncated`. */
  sellerCount: number;
  /** The cap (500) was hit: the map should ask for a narrower area. */
  truncated: boolean;
}

/** `CatalogPinsModel.MaxPins`: what the backend caps the pins at, named so the hint can say it. */
export const CATALOG_MAX_PINS = 500;
